var getOption = function getOption(haystack, needle) {
  if (needle === null) {
    return false;
  }

  return haystack.find(function (filter) {
    return filter.value === needle;
  }) || false;
};

export default getOption;